// 自定义 js
// 主题预留的 js 钩子见 https://benchmarkthemes.com/help-center/ignite/guides/javascript/

/* 优化后的 resize 监听事件 */
;(function() {
    var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            if (timeout) clearTimeout(timeout);
            running = true;
            var timeout = setTimeout(() => {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            },500)
        };
        obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle("resize", "optimizedResize");
})();

function updateCartStorage(event) {
  const cart = event.detail.cartData; // Get the updated content of the cart
  if (cart) {
    const items = cart.items;
    const itemIDArray = [];
    
    if (items.length > 0) {
      items.forEach((item) => {
        itemIDArray.push(item.variant_id);
      })
      sessionStorage.itemIDArray = JSON.stringify(itemIDArray);
    } else {
      sessionStorage.removeItem('itemIDArray');
    }
  }
}

document.addEventListener('cart-update', function(event) {
  console.log('update')
  updateCartStorage(event);
});
document.addEventListener('cart-remove', function(event) {
  console.log('remove: ', event)
  
  updateCartStorage(event);
});

// 滚动到指定元素位置
const scrollToTarget = (target, smoothScroll) => {
  let mql = window.matchMedia('(max-width: 767px)');
  let isMobile = mql.matches;
  let fixedHeaderHeight = 0;
  let distance = window.scrollY + target.getBoundingClientRect().top;
  const fixHeaderNavigation = document.querySelector('sticky-header');
  const ul = document.querySelector('#pProductOverviewMenu ul');
  const catalog = ul ? getComputedStyle(ul).height : '0px';
  if (fixHeaderNavigation) {
    const fixHeaderNavigationHeight = getComputedStyle(fixHeaderNavigation).height;
    fixedHeaderHeight = Number(fixHeaderNavigationHeight.replace('px', '')) + Number(catalog.replace('px', ''));
  }
  const headerCountdown = document.querySelector('.shopify-section-group-header-group.countdown-section');
  if (headerCountdown && !headerCountdown.classList.contains('hide')) {
    const headerCountDownHeight = getComputedStyle(headerCountdown).height;
    fixedHeaderHeight = fixedHeaderHeight + Number(headerCountDownHeight.replace('px', ''));
  }

  if (smoothScroll) {
    window.scrollTo({
      top: distance - fixedHeaderHeight + 1,
      left: 0,
      behavior: 'smooth'
    })
  } else {
    window.scrollTo(0, distance - fixedHeaderHeight + 1);
  }
}

// 获取 url 里 ? 后的指定 key 的值
function getURLParameter(key) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + key + "=([^&;]+?)(&|#|;|$)", "i").exec(
        location.search
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

// 打开页面，然后滚动到指定 ID
function getElement(id) {
  const target = document.getElementById(id);
  if (target) {
    scrollToTarget(target);
  } else {
    requestAnimationFrame(() => getElement(id)); // 若元素未找到，继续尝试
  }
}
const openAndScroll = () => {
  const targetId = getURLParameter('id');
  if (targetId) {
    console.log('targetId: ', targetId);
    getElement(targetId);
  }
};
openAndScroll();